export default {
  'kaburagi': {
    type: 'staff',
    title: '監督',
    name: '鏑木ひろ'
  },
  'kishimoto': {
    type: 'staff',
    title: '脚本・シリーズ構成',
    name: '岸本 卓・鏑木ひろ'
  },
  'kato': {
    type: 'staff',
    title: 'キャラクターデザイン',
    name: '加藤寛崇'
  },
  'sadamoto': {
    type: 'staff',
    title: 'オリジナルデザイン',
    name: '貞本義行'
  },
  'kosawa': {
    type: 'staff',
    title: '脚本監修',
    name: '古沢良太'
  },
  'ishibashi': {
    type: 'staff',
    title: '総作画監督',
    name: '加藤寛崇・石橋翔祐'
  },
  'tanji': {
    type: 'staff',
    title: 'コンセプトデザイン',
    name: '丹地陽子'
  },
  'syo5': {
    type: 'staff',
    title: 'イメージデザイン',
    name: 'syo5'
  },
  'teshima': {
    type: 'staff',
    title: '副監督',
    name: '手島舞'
  },
  'okuda': {
    type: 'staff',
    title: 'デザインワークス',
    name: '奥田明世・石橋翔祐'
  },
  'takeda': {
    type: 'staff',
    title: '美術監督',
    name: '竹田悠介・須藤裕美子'
  },
  'fujii': {
    type: 'staff',
    title: '美術設定',
    name: '藤井一志'
  },
  'kobari': {
    type: 'staff',
    title: '色彩設計',
    name: '小針裕子'
  },
  'izumida': {
    type: 'staff',
    title: '撮影監督',
    name: '出水田和人'
  },
  'imai': {
    type: 'staff',
    title: '編集',
    name: '今井大介'
  },
  'yamada': {
    type: 'staff',
    title: '音楽',
    name: 'やまだ豊'
  },
  'hata': {
    type: 'staff',
    title: '音響監督',
    name: 'はたしょう二'
  },
  'okada': {
    type: 'staff',
    title: 'アニメーションプロデューサー',
    name: '岡田麻衣子'
  },
  'wit': {
    type: 'staff',
    title: 'アニメーション制作',
    name: 'WIT STUDIO'
  },
  'komatsu': {
    type: 'cast',
    title: 'ドロシー',
    name: '小松由佳',
    image: '/assets/images/cast-raz-komatsu.jpg',
    comment:
      '<p>謎めいたスーパーキュートな無国籍ガール。何年かに一度、魂が乗り移るレベルで“私が心底恋に落ちる役との幸運な出会い”があります。その一人、大好きなドロシーにまさかまた会えるなんて！！！しかも彼女にまつわる物語。こんな幸せなことない。グレプリというクールで自由で丁寧な作品、今回も間違い無し！自信を持ってお届けします！シャレオツです！とにかく見て！お願い！</p>'
  },
  'takeuchi': {
    type: 'cast',
    title: '江 品爵（ジェイ）',
    name: '武内駿輔',
    image: '/assets/images/cast-raz-takeuchi.jpg',
    comment:
      '<p>人物描写に奥行きがあり、アフレコがとても楽しい時間でした。続編ということですが、前作を知らない方でも楽しんでいただける内容になっていると思います。にーちゃんねーちゃん、オジサンたちが繰り広げる、渋ポップな世界観をどうぞ楽しんでいただけますと幸いです。</p>'
  },
  'mamiya': {
    type: 'cast',
    title: '楊 崑義（アイ）',
    name: '間宮康弘',
    image: '/assets/images/cast-raz-mamiya.jpg',
    comment:
      '<p>『楊崑義（アイ）』を演じさせて頂いた間宮康弘ってもんだ。 ドロシーは記憶喪失で生きていた！！そして現れるイケメン・ジェイ。動き始める組織のボス・王。 激しい騙し合いの末、最後に立っている黒幕は？ 何より、アイに活躍の場はあるのか？！ アニメ『GREAT PRETENDER razbliuto』楽しんでくれよな！</p>'
  },
  'okitsu': {
    type: 'cast',
    title: '林',
    name: '興津和幸',
    image: '/assets/images/cast-raz-okitsu.jpg',
    comment:
      '<p>林はスタイリッシュお洒落イヤミ眼鏡。ハヤシじゃなくてリンと読みます。それぞれのキャラクターに秘密があり、何かを企んでいる。誰が敵で味方なのか、毎話続きが気になり、ドキドキして収録に臨みました。なんだか皆んな怪しいですけど楽しい作品になっていると思いますので、どーぞご期待ください！！</p>'
  },
  'kase': {
    type: 'cast',
    title: '王 翊碁',
    name: '加瀬康之',
    image: '/assets/images/cast-raz-kase.jpg',
    comment:
      '<p>王翊碁役を担当させて頂きました、加瀬康之です。王(ワン)がどういうポジションで主人公たちと絡むのか、ドキドキワクワクしながら楽しく演じさせてもらいました。みなさん、お楽しみに！</p>'
  },
  'kanuka': {
    type: 'cast',
    title: '蔡',
    name: 'かぬか光明',
    image: '/assets/images/cast-raz-kanuka.jpg',
    comment:
      '<p>アニメ『GREAT PRETENDER razbliuto』で、蔡役を担当しました、かぬか光明です。 役作りはもちろん、アフレコも全力で取り組みました！ 是非ご期待ください！！ 皆様、よろしくお願いいたします！！</p>'
  },
  'ise': {
    type: 'cast',
    title: 'ビンイェン',
    name: '伊瀬茉莉也',
    image: '/assets/images/cast-raz-ise.jpg',
    comment:
      '<p>この度、ビンイェンを演じさせていただくことなりました、伊瀬茉莉也です！私は今回の続編、外伝から参加させて頂くことになり、どんな座組のどんな世界観のお話なんだろうととても楽しみにしていました。ビンイェンのミステリアスで謎めいた部分が物語の中で紐解かれていくのか…？どうぞご期待下さい！</p>'
  }
}



// WEBPACK FOOTER //
// ./src/data/razbliuto/staff.js